import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { media } from '../../styles/style-utils';

const Option = styled.label`
  display: inline-flex;
  cursor: pointer;
  position: relative;
  user-select: none;
  ${media.large`
    margin-right: 16px;
  `}
`;

const Checkbox = styled.input`
  display: inline-block;
  width: auto;
`;

export function CookieBannerSelectionOption(props) {
  return (
    <Option>
      <Checkbox
        type="checkbox"
        onChange={props.onChange}
        checked={props.checked}
        disabled={props.disabled}
        name={props.name}
        id={`cookie-banner-${props.name}`}
      />
      <span>{props.label}</span>
    </Option>
  );
}

CookieBannerSelectionOption.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  name: PropTypes.any.isRequired,
  label: PropTypes.any.isRequired,
};



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/cookieBanner/CookieBannerSelectionOption.js